<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="how-this-works">
<h1>How This Works</h1>
<p>This is an oracle book. It works like oracle cards, but rather than shuﬄing, turn to the page number you’re called to, and receive a message that you are ready to learn or remember.</p>
<p>Or read the book sequentially. Or front to back, back to front, inside out or outside in. Read it upside down if you want, but I wouldn’t recommend it. You choose. You will be called to the lessons you need. Trust the process. Trust your gut.</p>
<p>These are the lessons I have learned on my journey toward peace. I am not here to convince anyone of anything or to tell you how to heal/feel/be/exist. I am here to remind you of what you already know. To remind you of what you have forgotten. What you forgot to remember, and what you remembered to forget. You are here to have a human experience, but you have forgotten that you are not your thoughts. You are a clear body of water, and your thoughts are just sediment.</p>
<p>Enjoy.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?5c18888b